export const drawerStyles = {
  components: {
    Drawer: {
      variants: {
        glass: {
          dialogContainer: {
            bg:'transparent',
          },
          dialog: {
            background:'transparent',
            borderRadius:'7px',
          },
        },
      },
    },
  },
};
